import React from 'react'
import { Navigate } from 'react-router-dom'
import { Box, Toolbar } from '@mui/material'

import { useAuth, useDrawer } from '~/src/hooks'
import { Header, Sidebar } from '~/src/components/organisms'
import { MainView } from '~/src/components/molecules'

const MemoizedMainView = React.memo(MainView)

type TProtectedPageProps = {
  pageTitle?: string
  children: React.ReactNode
}

export const ProtectedPage: React.FC<TProtectedPageProps> = ({ pageTitle = '', children }) => {
  const { isAuthenticated } = useAuth()
  const { isDrawerOpen } = useDrawer()

  return !isAuthenticated ? (
    <Navigate to={'/admin/login'}></Navigate>
  ) : (
    <>
      <Header title={pageTitle} open={isDrawerOpen} />
      {children}
    </>
  )
}
